import EmbedbaseClient from './EmbedbaseClient';
import EmbedbaseExperimentalClient from './EmbedbaseExperimentalClient';
export { default as EmbedbaseClient } from './EmbedbaseClient';
export { default as EmbedbaseExperimentalClient } from './EmbedbaseExperimentalClient';
/**
 * Creates a new Embedbase Client.
 */
export const createClient = (embedbaseUrl, embedbaseKey) => {
    return new EmbedbaseClient(embedbaseUrl, embedbaseKey);
};
/**
 * Creates a new experimental Embedbase Client.
 * This client is not recommended for production use.
 */
export const createExperimentalClient = (embedbaseUrl, embedbaseKey) => {
    return new EmbedbaseExperimentalClient(embedbaseUrl, embedbaseKey);
};
export { merge, splitText } from './split';
//# sourceMappingURL=index.js.map